import { fetchRest, getApiBaseUrl } from '@/config/api'

const API_URL = getApiBaseUrl()

export interface ImportSheetResult {
  success: boolean
  total: number
  updated: number
  errors: { ligne: number; message: string }[]
}

// Le fichier "catalogue" contient deux feuilles : Stock + Promotions.
export interface CatalogueImportResult {
  stock: ImportSheetResult
  promo: ImportSheetResult
}

export async function exportStockExcel(idVendeur: number) {
  const response = await fetchRest(
    `${API_URL}/produits-stock/export-excel?id_vendeur=${idVendeur}`,
    { method: 'GET' },
  )

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || "Erreur lors de l'export du stock")
  }

  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `catalogue_vendeur_${idVendeur}.xlsx`)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export async function importStockExcel(file: File): Promise<CatalogueImportResult> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetchRest(`${API_URL}/produits-stock/import-excel`, {
    method: 'POST',
    body: formData,
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || "Erreur lors de l'import du catalogue")
  }

  return await response.json()
}

export async function validateStockExcel(file: File): Promise<CatalogueImportResult> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetchRest(`${API_URL}/produits-stock/import-excel?dryRun=true`, {
    method: 'POST',
    body: formData,
  })

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.message || "Erreur lors de la validation du catalogue")
  }

  return await response.json()
}
